var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3865 0.910217H9.41216C9.02277 0.910217 8.70703 1.22587 8.70703 1.61533V8.58912C8.70703 8.97858 9.02277 9.29423 9.41216 9.29423H16.3865C16.7759 9.29423 17.0916 8.97858 17.0916 8.58912V1.61533C17.0916 1.22587 16.7759 0.910217 16.3865 0.910217Z",
    fill: "#4A49CB",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58965 8.70441H1.61528C1.22589 8.70441 0.910156 9.02006 0.910156 9.40952V16.3833C0.910156 16.7728 1.22589 17.0884 1.61528 17.0884H8.58965C8.97904 17.0884 9.29477 16.7728 9.29477 16.3833V9.40952C9.29477 9.02006 8.97904 8.70441 8.58965 8.70441Z",
    fill: "#4A49CB",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3865 8.70441H9.41216C9.02277 8.70441 8.70703 9.02006 8.70703 9.40952V16.3833C8.70703 16.7728 9.02277 17.0884 9.41216 17.0884H16.3865C16.7759 17.0884 17.0916 16.7728 17.0916 16.3833V9.40952C17.0916 9.02006 16.7759 8.70441 16.3865 8.70441Z",
    fill: "#4A49CB",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogo);
export default __webpack_public_path__ + "static/media/icon-logo.b40f3f635157f1039263005ca22457ef.svg";
export { ForwardRef as ReactComponent };